import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios, { MEDIA_BASE_URL } from "../../axios/axios";
import Navbar from "../Navbar";
import Footer from "../Footer";

const ColorCorrectionOrder = () => {
  const [services, setServices] = useState([]);
  const getServices = useCallback(async () => {
    try {
      const response = await axios.get("/services/getServices");
      setServices(response.data.services);
    } catch (error) {
      console.log(error);
    }
  }, []);
  useEffect(() => {
    getServices();
  }, [getServices]);

  return (
    <>
      <Navbar />
      <div className="order_bg">
        <h1>Order</h1>
      </div>
      <h2 className="text-center my-4 prata-regular">
        Color Correction 
      </h2>
      <div className="mx-5 py-5">
        <div className="row">
          {services
            ?.filter((service) => service?.service === "Color Correction")
            .map((val, index) => (
              <div key={index} className="col-md-3">
                <Link
                  to={`/colorcorrection-form/${val.id
                    .replaceAll(" ", "-")
                    .replaceAll("/", "_")}`}
                  className="border-1 card text-decoration-none pt-5"
                >
                  <img
                    src={`${MEDIA_BASE_URL}/${val.image}`}
                    crossOrigin="anonymous"
                    style={{ width: "100%", height: "18rem" }}
                    className="object-fit-cover"
                    alt=""
                  />
                  <div className="px-3">
                    <h5 className="py-4 mb-0 prata-regular">{val.title}</h5>
                    <p className=""> ${val.price}</p>
                  </div>
                  <p
                    className="mb-0 py-3 fs-14 px-3 prata-regular"
                    style={{ borderTop: "1px solid #ccc" }}
                  >
                    {val.description}
                  </p>
                </Link>
              </div>
            ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ColorCorrectionOrder;
